import { type } from "arktype";

export const googleRsvpFilterSchema = type("'exclude_declined' | 'all' | 'accepted_only'");
export type GoogleRsvpFilter = typeof googleRsvpFilterSchema.infer;
export const DEFAULT_GOOGLE_RSVP_FILTER: GoogleRsvpFilter = "exclude_declined";
export const GOOGLE_RSVP_FILTER_OPTIONS: { value: GoogleRsvpFilter; label: string }[] = [
  { value: "exclude_declined", label: "Exclude declined (default)" },
  { value: "all", label: "Don't exclude any responses" },
  { value: "accepted_only", label: "Accepted only" },
];
